module.exports = __webpack_public_path__ + "static/media/kuro_Artificial_intelligence_ill.3d68d094.svg";